import React from 'react'
import { Row } from 'antd'

const RightContent = ({ image, title }) => {
    return (
        <Row justify="center" align="middle" type="flex" style={{ height: '100%' }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <img src={image} height={450} />
                <h1 style={{ color: 'white', paddingTop: 60, fontSize: 32 }}>{title}</h1>
            </div>
        </Row>
    )
}

export default RightContent
